//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import axios, { AxiosError } from 'axios';

export class LoanApplicationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    listCustomerLoanApplications( cancelToken?: CancelToken): Promise<ListCustomerApplicationsResponse> {
        let url_ = this.baseUrl + "/api/customer/loan-application";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCustomerLoanApplications(_response);
        });
    }

    protected processListCustomerLoanApplications(response: AxiosResponse): Promise<ListCustomerApplicationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListCustomerApplicationsResponse.fromJS(resultData200);
            return Promise.resolve<ListCustomerApplicationsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListCustomerApplicationsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    submitLoanApplication(body: SubmitLoanApplicationRequest | undefined, cancelToken?: CancelToken): Promise<SubmitLoanApplicationResponse> {
        let url_ = this.baseUrl + "/api/customer/loan-application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitLoanApplication(_response);
        });
    }

    protected processSubmitLoanApplication(response: AxiosResponse): Promise<SubmitLoanApplicationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SubmitLoanApplicationResponse.fromJS(resultData201);
            return Promise.resolve<SubmitLoanApplicationResponse>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmitLoanApplicationResponse>(null as any);
    }

    /**
     * @return OK
     */
    getLastSubmittedApplications( cancelToken?: CancelToken): Promise<GetLastSubmittedApplicationsResponse> {
        let url_ = this.baseUrl + "/api/customer/loan-application/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLastSubmittedApplications(_response);
        });
    }

    protected processGetLastSubmittedApplications(response: AxiosResponse): Promise<GetLastSubmittedApplicationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLastSubmittedApplicationsResponse.fromJS(resultData200);
            return Promise.resolve<GetLastSubmittedApplicationsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLastSubmittedApplicationsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getLoanApplicationById(id: string, cancelToken?: CancelToken): Promise<GetLoanApplicationResponse> {
        let url_ = this.baseUrl + "/api/customer/loan-application/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLoanApplicationById(_response);
        });
    }

    protected processGetLoanApplicationById(response: AxiosResponse): Promise<GetLoanApplicationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetLoanApplicationResponse.fromJS(resultData200);
            return Promise.resolve<GetLoanApplicationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLoanApplicationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancelLoanApplication(id: string, body: CancelLoanApplicationRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/loan-application/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelLoanApplication(_response);
        });
    }

    protected processCancelLoanApplication(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getOpenLoanApplications( cancelToken?: CancelToken): Promise<GetOpenApplicationsQueryResponse> {
        let url_ = this.baseUrl + "/api/customer/loan-application/open";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenLoanApplications(_response);
        });
    }

    protected processGetOpenLoanApplications(response: AxiosResponse): Promise<GetOpenApplicationsQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOpenApplicationsQueryResponse.fromJS(resultData200);
            return Promise.resolve<GetOpenApplicationsQueryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOpenApplicationsQueryResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAcceptedOfferInApplication(id: string, cancelToken?: CancelToken): Promise<PartnerSubmissionClientView> {
        let url_ = this.baseUrl + "/api/customer/loan-application/{id}/accepts";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAcceptedOfferInApplication(_response);
        });
    }

    protected processGetAcceptedOfferInApplication(response: AxiosResponse): Promise<PartnerSubmissionClientView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PartnerSubmissionClientView.fromJS(resultData200);
            return Promise.resolve<PartnerSubmissionClientView>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerSubmissionClientView>(null as any);
    }

    /**
     * @param dual (optional) 
     * @return OK
     */
    acceptOffer(id: string, pid: string, dual: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/loan-application/{id}/partners/{pid}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pid === undefined || pid === null)
            throw new globalThis.Error("The parameter 'pid' must be defined.");
        url_ = url_.replace("{pid}", encodeURIComponent("" + pid));
        if (dual === null)
            throw new globalThis.Error("The parameter 'dual' cannot be null.");
        else if (dual !== undefined)
            url_ += "dual=" + encodeURIComponent("" + dual) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptOffer(_response);
        });
    }

    protected processAcceptOffer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveToCache(body: AddLoanApplicationCacheRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/loan-application/cache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveToCache(_response);
        });
    }

    protected processSaveToCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getFromCache( cancelToken?: CancelToken): Promise<LoanApplicationCacheDto> {
        let url_ = this.baseUrl + "/api/customer/loan-application/cache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFromCache(_response);
        });
    }

    protected processGetFromCache(response: AxiosResponse): Promise<LoanApplicationCacheDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoanApplicationCacheDto.fromJS(resultData200);
            return Promise.resolve<LoanApplicationCacheDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoanApplicationCacheDto>(null as any);
    }

    /**
     * @return OK
     */
    getLastSubmittedForm( cancelToken?: CancelToken): Promise<LoanApplicationSubmissionFormDto> {
        let url_ = this.baseUrl + "/api/customer/loan-application/form";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLastSubmittedForm(_response);
        });
    }

    protected processGetLastSubmittedForm(response: AxiosResponse): Promise<LoanApplicationSubmissionFormDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoanApplicationSubmissionFormDto.fromJS(resultData200);
            return Promise.resolve<LoanApplicationSubmissionFormDto>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("No Content", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoanApplicationSubmissionFormDto>(null as any);
    }

    /**
     * @return OK
     */
    effectiveInterestRate( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/statistics/averages/effective-interest-rate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEffectiveInterestRate(_response);
        });
    }

    protected processEffectiveInterestRate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AddLoanApplicationCacheRequest implements IAddLoanApplicationCacheRequest {
    data!: LoanApplicationCacheDto;

    constructor(data?: IAddLoanApplicationCacheRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.data = data.data && !(data.data as any).toJSON ? new LoanApplicationCacheDto(data.data) : this.data as LoanApplicationCacheDto;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? LoanApplicationCacheDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): AddLoanApplicationCacheRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddLoanApplicationCacheRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IAddLoanApplicationCacheRequest {
    data: ILoanApplicationCacheDto;
}

export class Applicant implements IApplicant {
    firstName!: string;
    middleName!: string | undefined;
    lastName!: string;
    phoneNumber!: string;
    email!: string;
    address!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    nationality!: string;
    birthDate!: DateYMD;
    education!: EducationType | undefined;
    childrenUnder18!: NumberOfChildren | undefined;
    maritalStatus!: MaritalStatusType | undefined;
    spouseGrossYearlyIncome!: number | undefined;
    employment!: EmploymentType | undefined;
    employerName!: string;
    employmentSince!: DateYMD;
    hasLivedInNorwayLast3Years!: boolean | undefined;

    constructor(data?: IApplicant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.birthDate = data.birthDate && !(data.birthDate as any).toJSON ? new DateYMD(data.birthDate) : this.birthDate as DateYMD;
            this.employmentSince = data.employmentSince && !(data.employmentSince as any).toJSON ? new DateYMD(data.employmentSince) : this.employmentSince as DateYMD;
        }
        if (!data) {
            this.birthDate = new DateYMD();
            this.employmentSince = new DateYMD();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.nationality = _data["nationality"];
            this.birthDate = _data["birthDate"] ? DateYMD.fromJS(_data["birthDate"]) : new DateYMD();
            this.education = _data["education"];
            this.childrenUnder18 = _data["childrenUnder18"];
            this.maritalStatus = _data["maritalStatus"];
            this.spouseGrossYearlyIncome = _data["spouseGrossYearlyIncome"];
            this.employment = _data["employment"];
            this.employerName = _data["employerName"];
            this.employmentSince = _data["employmentSince"] ? DateYMD.fromJS(_data["employmentSince"]) : new DateYMD();
            this.hasLivedInNorwayLast3Years = _data["hasLivedInNorwayLast3Years"];
        }
    }

    static fromJS(data: any): Applicant {
        data = typeof data === 'object' ? data : {};
        let result = new Applicant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["nationality"] = this.nationality;
        data["birthDate"] = this.birthDate ? this.birthDate.toJSON() : undefined as any;
        data["education"] = this.education;
        data["childrenUnder18"] = this.childrenUnder18;
        data["maritalStatus"] = this.maritalStatus;
        data["spouseGrossYearlyIncome"] = this.spouseGrossYearlyIncome;
        data["employment"] = this.employment;
        data["employerName"] = this.employerName;
        data["employmentSince"] = this.employmentSince ? this.employmentSince.toJSON() : undefined as any;
        data["hasLivedInNorwayLast3Years"] = this.hasLivedInNorwayLast3Years;
        return data;
    }
}

export interface IApplicant {
    firstName: string;
    middleName: string | undefined;
    lastName: string;
    phoneNumber: string;
    email: string;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    nationality: string;
    birthDate: IDateYMD;
    education: EducationType | undefined;
    childrenUnder18: NumberOfChildren | undefined;
    maritalStatus: MaritalStatusType | undefined;
    spouseGrossYearlyIncome: number | undefined;
    employment: EmploymentType | undefined;
    employerName: string;
    employmentSince: IDateYMD;
    hasLivedInNorwayLast3Years: boolean | undefined;
}

export class ApplicationComboOfferClientView implements IApplicationComboOfferClientView {
    amountOffered!: number;
    nominalInterest!: number;
    effectiveInterest!: number;
    repaymentPeriodsInMonths!: number;
    periodicServiceFee!: number;
    state!: ComboOfferState;
    readonly costPerPeriod!: number;
    readonly totalCost!: number;
    readonly totalInterest!: number;

    constructor(data?: IApplicationComboOfferClientView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountOffered = _data["amountOffered"];
            this.nominalInterest = _data["nominalInterest"];
            this.effectiveInterest = _data["effectiveInterest"];
            this.repaymentPeriodsInMonths = _data["repaymentPeriodsInMonths"];
            this.periodicServiceFee = _data["periodicServiceFee"];
            this.state = _data["state"];
            (this as any).costPerPeriod = _data["costPerPeriod"];
            (this as any).totalCost = _data["totalCost"];
            (this as any).totalInterest = _data["totalInterest"];
        }
    }

    static fromJS(data: any): ApplicationComboOfferClientView {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationComboOfferClientView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountOffered"] = this.amountOffered;
        data["nominalInterest"] = this.nominalInterest;
        data["effectiveInterest"] = this.effectiveInterest;
        data["repaymentPeriodsInMonths"] = this.repaymentPeriodsInMonths;
        data["periodicServiceFee"] = this.periodicServiceFee;
        data["state"] = this.state;
        data["costPerPeriod"] = this.costPerPeriod;
        data["totalCost"] = this.totalCost;
        data["totalInterest"] = this.totalInterest;
        return data;
    }
}

export interface IApplicationComboOfferClientView {
    amountOffered: number;
    nominalInterest: number;
    effectiveInterest: number;
    repaymentPeriodsInMonths: number;
    periodicServiceFee: number;
    state: ComboOfferState;
    costPerPeriod: number;
    totalCost: number;
    totalInterest: number;
}

export class ApplicationOfferClientView implements IApplicationOfferClientView {
    amountOffered!: number;
    nominalInterest!: number;
    effectiveInterest!: number;
    repaymentPeriodsInMonths!: number;
    periodicServiceFee!: number;
    setupFee!: number;
    signingURL!: string | undefined;
    accepted!: boolean;
    disbursed!: boolean;
    disbursedAt!: Date | undefined;
    readonly costPerPeriod!: number;
    readonly totalCost!: number;
    readonly totalInterest!: number;
    quality!: OfferQuality;

    constructor(data?: IApplicationOfferClientView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountOffered = _data["amountOffered"];
            this.nominalInterest = _data["nominalInterest"];
            this.effectiveInterest = _data["effectiveInterest"];
            this.repaymentPeriodsInMonths = _data["repaymentPeriodsInMonths"];
            this.periodicServiceFee = _data["periodicServiceFee"];
            this.setupFee = _data["setupFee"];
            this.signingURL = _data["signingURL"];
            this.accepted = _data["accepted"];
            this.disbursed = _data["disbursed"];
            this.disbursedAt = _data["disbursedAt"] ? new Date(_data["disbursedAt"].toString()) : undefined as any;
            (this as any).costPerPeriod = _data["costPerPeriod"];
            (this as any).totalCost = _data["totalCost"];
            (this as any).totalInterest = _data["totalInterest"];
            this.quality = _data["quality"];
        }
    }

    static fromJS(data: any): ApplicationOfferClientView {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationOfferClientView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountOffered"] = this.amountOffered;
        data["nominalInterest"] = this.nominalInterest;
        data["effectiveInterest"] = this.effectiveInterest;
        data["repaymentPeriodsInMonths"] = this.repaymentPeriodsInMonths;
        data["periodicServiceFee"] = this.periodicServiceFee;
        data["setupFee"] = this.setupFee;
        data["signingURL"] = this.signingURL;
        data["accepted"] = this.accepted;
        data["disbursed"] = this.disbursed;
        data["disbursedAt"] = this.disbursedAt ? this.disbursedAt.toISOString() : undefined as any;
        data["costPerPeriod"] = this.costPerPeriod;
        data["totalCost"] = this.totalCost;
        data["totalInterest"] = this.totalInterest;
        data["quality"] = this.quality;
        return data;
    }
}

export interface IApplicationOfferClientView {
    amountOffered: number;
    nominalInterest: number;
    effectiveInterest: number;
    repaymentPeriodsInMonths: number;
    periodicServiceFee: number;
    setupFee: number;
    signingURL: string | undefined;
    accepted: boolean;
    disbursed: boolean;
    disbursedAt: Date | undefined;
    costPerPeriod: number;
    totalCost: number;
    totalInterest: number;
    quality: OfferQuality;
}

export enum ApplicationSource {
    Unknown = "Unknown",
    Webform = "Webform",
    App = "App",
    RateCheck = "RateCheck",
    Management = "Management",
}

export class Cadastral implements ICadastral {
    municipalityNumber!: number;
    cadastralUnitNumber!: number;
    propertyUnitNumber!: number;
    leaseNumber!: number;
    unitNumber!: number;

    constructor(data?: ICadastral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.municipalityNumber = _data["municipalityNumber"];
            this.cadastralUnitNumber = _data["cadastralUnitNumber"];
            this.propertyUnitNumber = _data["propertyUnitNumber"];
            this.leaseNumber = _data["leaseNumber"];
            this.unitNumber = _data["unitNumber"];
        }
    }

    static fromJS(data: any): Cadastral {
        data = typeof data === 'object' ? data : {};
        let result = new Cadastral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["municipalityNumber"] = this.municipalityNumber;
        data["cadastralUnitNumber"] = this.cadastralUnitNumber;
        data["propertyUnitNumber"] = this.propertyUnitNumber;
        data["leaseNumber"] = this.leaseNumber;
        data["unitNumber"] = this.unitNumber;
        return data;
    }
}

export interface ICadastral {
    municipalityNumber: number;
    cadastralUnitNumber: number;
    propertyUnitNumber: number;
    leaseNumber: number;
    unitNumber: number;
}

export class CancelLoanApplicationRequest implements ICancelLoanApplicationRequest {
    reason!: Reason | undefined;

    constructor(data?: ICancelLoanApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.reason = data.reason && !(data.reason as any).toJSON ? new Reason(data.reason) : this.reason as Reason;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] ? Reason.fromJS(_data["reason"]) : undefined as any;
        }
    }

    static fromJS(data: any): CancelLoanApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelLoanApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason ? this.reason.toJSON() : undefined as any;
        return data;
    }
}

export interface ICancelLoanApplicationRequest {
    reason: IReason | undefined;
}

export enum CancellationReasonType {
    InterestRate = "InterestRate",
    RepaymentPeriod = "RepaymentPeriod",
    LoanAmount = "LoanAmount",
    ReceivedBetterOfferElsewhere = "ReceivedBetterOfferElsewhere",
    NoneOfTheAbove = "NoneOfTheAbove",
    NotSelected = "NotSelected",
}

export class Client implements IClient {
    source!: ApplicationSource;
    appVersion!: string;

    constructor(data?: IClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.appVersion = _data["appVersion"];
        }
    }

    static fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["appVersion"] = this.appVersion;
        return data;
    }
}

export interface IClient {
    source: ApplicationSource;
    appVersion: string;
}

export class CoApplicant implements ICoApplicant {
    firstName!: string;
    middleName!: string | undefined;
    lastName!: string;
    socialNumber!: string;
    email!: string;
    phoneNumber!: string;
    maritalStatus!: MaritalStatusType | undefined;
    hasLivedInNorwayLast3Years!: boolean | undefined;
    education!: EducationType | undefined;
    yearlyGrossIncome!: number | undefined;
    monthlyNetIncome!: number | undefined;
    employment!: EmploymentType | undefined;
    employmentSince!: DateYMD;
    employerName!: string;
    housingSituation!: HousingSituation | undefined;
    rentExpense!: number | undefined;
    childrenUnder18!: NumberOfChildren | undefined;
    livesWithMainApplicant!: boolean | undefined;
    hasRentIncome!: boolean | undefined;
    rentIncome!: number | undefined;
    hasNorwegianCitizenship!: boolean | undefined;
    hasMortgage!: boolean | undefined;
    remainingMortgageAmount!: number | undefined;
    paymentOnMortgageMonthly!: number | undefined;
    hasPaymentRemarks!: SelfReportedPaymentRemarks | undefined;
    hasOtherIncome!: boolean | undefined;
    otherIncome!: number | undefined;
    receivesChildSupport!: boolean | undefined;
    childSupportReceivedMonthly!: number | undefined;

    constructor(data?: ICoApplicant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.employmentSince = data.employmentSince && !(data.employmentSince as any).toJSON ? new DateYMD(data.employmentSince) : this.employmentSince as DateYMD;
        }
        if (!data) {
            this.employmentSince = new DateYMD();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.socialNumber = _data["socialNumber"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.maritalStatus = _data["maritalStatus"];
            this.hasLivedInNorwayLast3Years = _data["hasLivedInNorwayLast3Years"];
            this.education = _data["education"];
            this.yearlyGrossIncome = _data["yearlyGrossIncome"];
            this.monthlyNetIncome = _data["monthlyNetIncome"];
            this.employment = _data["employment"];
            this.employmentSince = _data["employmentSince"] ? DateYMD.fromJS(_data["employmentSince"]) : new DateYMD();
            this.employerName = _data["employerName"];
            this.housingSituation = _data["housingSituation"];
            this.rentExpense = _data["rentExpense"];
            this.childrenUnder18 = _data["childrenUnder18"];
            this.livesWithMainApplicant = _data["livesWithMainApplicant"];
            this.hasRentIncome = _data["hasRentIncome"];
            this.rentIncome = _data["rentIncome"];
            this.hasNorwegianCitizenship = _data["hasNorwegianCitizenship"];
            this.hasMortgage = _data["hasMortgage"];
            this.remainingMortgageAmount = _data["remainingMortgageAmount"];
            this.paymentOnMortgageMonthly = _data["paymentOnMortgageMonthly"];
            this.hasPaymentRemarks = _data["hasPaymentRemarks"];
            this.hasOtherIncome = _data["hasOtherIncome"];
            this.otherIncome = _data["otherIncome"];
            this.receivesChildSupport = _data["receivesChildSupport"];
            this.childSupportReceivedMonthly = _data["childSupportReceivedMonthly"];
        }
    }

    static fromJS(data: any): CoApplicant {
        data = typeof data === 'object' ? data : {};
        let result = new CoApplicant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["socialNumber"] = this.socialNumber;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["maritalStatus"] = this.maritalStatus;
        data["hasLivedInNorwayLast3Years"] = this.hasLivedInNorwayLast3Years;
        data["education"] = this.education;
        data["yearlyGrossIncome"] = this.yearlyGrossIncome;
        data["monthlyNetIncome"] = this.monthlyNetIncome;
        data["employment"] = this.employment;
        data["employmentSince"] = this.employmentSince ? this.employmentSince.toJSON() : undefined as any;
        data["employerName"] = this.employerName;
        data["housingSituation"] = this.housingSituation;
        data["rentExpense"] = this.rentExpense;
        data["childrenUnder18"] = this.childrenUnder18;
        data["livesWithMainApplicant"] = this.livesWithMainApplicant;
        data["hasRentIncome"] = this.hasRentIncome;
        data["rentIncome"] = this.rentIncome;
        data["hasNorwegianCitizenship"] = this.hasNorwegianCitizenship;
        data["hasMortgage"] = this.hasMortgage;
        data["remainingMortgageAmount"] = this.remainingMortgageAmount;
        data["paymentOnMortgageMonthly"] = this.paymentOnMortgageMonthly;
        data["hasPaymentRemarks"] = this.hasPaymentRemarks;
        data["hasOtherIncome"] = this.hasOtherIncome;
        data["otherIncome"] = this.otherIncome;
        data["receivesChildSupport"] = this.receivesChildSupport;
        data["childSupportReceivedMonthly"] = this.childSupportReceivedMonthly;
        return data;
    }
}

export interface ICoApplicant {
    firstName: string;
    middleName: string | undefined;
    lastName: string;
    socialNumber: string;
    email: string;
    phoneNumber: string;
    maritalStatus: MaritalStatusType | undefined;
    hasLivedInNorwayLast3Years: boolean | undefined;
    education: EducationType | undefined;
    yearlyGrossIncome: number | undefined;
    monthlyNetIncome: number | undefined;
    employment: EmploymentType | undefined;
    employmentSince: IDateYMD;
    employerName: string;
    housingSituation: HousingSituation | undefined;
    rentExpense: number | undefined;
    childrenUnder18: NumberOfChildren | undefined;
    livesWithMainApplicant: boolean | undefined;
    hasRentIncome: boolean | undefined;
    rentIncome: number | undefined;
    hasNorwegianCitizenship: boolean | undefined;
    hasMortgage: boolean | undefined;
    remainingMortgageAmount: number | undefined;
    paymentOnMortgageMonthly: number | undefined;
    hasPaymentRemarks: SelfReportedPaymentRemarks | undefined;
    hasOtherIncome: boolean | undefined;
    otherIncome: number | undefined;
    receivesChildSupport: boolean | undefined;
    childSupportReceivedMonthly: number | undefined;
}

export enum ComboOfferState {
    OfferGiven = "OfferGiven",
    Cancelled = "Cancelled",
    PaidOut = "PaidOut",
}

export class DateYMD implements IDateYMD {
    year!: number;
    month!: number | undefined;
    day!: number | undefined;

    constructor(data?: IDateYMD) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.day = _data["day"];
        }
    }

    static fromJS(data: any): DateYMD {
        data = typeof data === 'object' ? data : {};
        let result = new DateYMD();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["day"] = this.day;
        return data;
    }
}

export interface IDateYMD {
    year: number;
    month: number | undefined;
    day: number | undefined;
}

export enum DebtType {
    CreditCard = "CreditCard",
    ConsumerLoan = "ConsumerLoan",
    StudentLoan = "StudentLoan",
    Mortgage = "Mortgage",
    CarLoan = "CarLoan",
    CommonDebt = "CommonDebt",
    PrivateLoan = "PrivateLoan",
    Collection = "Collection",
    ChargeCard = "ChargeCard",
}

export enum EducationType {
    ElementarySchool = "ElementarySchool",
    UpperSecondarySchool = "UpperSecondarySchool",
    HigherEducation12 = "HigherEducation12",
    Bachelor = "Bachelor",
    Master = "Master",
    Fagskole = "Fagskole",
    UniversitetHøgskole = "UniversitetHøgskole",
}

export enum EmploymentType {
    FullTimePrivate = "FullTimePrivate",
    FullTimePublic = "FullTimePublic",
    TemporarilyLaidOff = "TemporarilyLaidOff",
    DisabilityAid = "DisabilityAid",
    TemporaryEmployment = "TemporaryEmployment",
    SoleProprietorship = "SoleProprietorship",
    Rehabilitation = "Rehabilitation",
    Student = "Student",
    Retired = "Retired",
    Others = "Others",
}

export class GetLastSubmittedApplicationsResponse implements IGetLastSubmittedApplicationsResponse {
    consumerLoan!: LoanApplicationClientView | undefined;
    restartLoan!: LoanApplicationClientView | undefined;

    constructor(data?: IGetLastSubmittedApplicationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.consumerLoan = data.consumerLoan && !(data.consumerLoan as any).toJSON ? new LoanApplicationClientView(data.consumerLoan) : this.consumerLoan as LoanApplicationClientView;
            this.restartLoan = data.restartLoan && !(data.restartLoan as any).toJSON ? new LoanApplicationClientView(data.restartLoan) : this.restartLoan as LoanApplicationClientView;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumerLoan = _data["consumerLoan"] ? LoanApplicationClientView.fromJS(_data["consumerLoan"]) : undefined as any;
            this.restartLoan = _data["restartLoan"] ? LoanApplicationClientView.fromJS(_data["restartLoan"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLastSubmittedApplicationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLastSubmittedApplicationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerLoan"] = this.consumerLoan ? this.consumerLoan.toJSON() : undefined as any;
        data["restartLoan"] = this.restartLoan ? this.restartLoan.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLastSubmittedApplicationsResponse {
    consumerLoan: ILoanApplicationClientView | undefined;
    restartLoan: ILoanApplicationClientView | undefined;
}

export class GetLoanApplicationResponse implements IGetLoanApplicationResponse {
    application!: LoanApplicationClientView | undefined;

    constructor(data?: IGetLoanApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.application = data.application && !(data.application as any).toJSON ? new LoanApplicationClientView(data.application) : this.application as LoanApplicationClientView;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? LoanApplicationClientView.fromJS(_data["application"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLoanApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLoanApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLoanApplicationResponse {
    application: ILoanApplicationClientView | undefined;
}

export class GetOpenApplicationsQueryResponse implements IGetOpenApplicationsQueryResponse {
    consumerLoan!: OpenApplicationResult;
    restartLoan!: OpenApplicationResult;
    creditCardLoan!: OpenApplicationResult;

    constructor(data?: IGetOpenApplicationsQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.consumerLoan = data.consumerLoan && !(data.consumerLoan as any).toJSON ? new OpenApplicationResult(data.consumerLoan) : this.consumerLoan as OpenApplicationResult;
            this.restartLoan = data.restartLoan && !(data.restartLoan as any).toJSON ? new OpenApplicationResult(data.restartLoan) : this.restartLoan as OpenApplicationResult;
            this.creditCardLoan = data.creditCardLoan && !(data.creditCardLoan as any).toJSON ? new OpenApplicationResult(data.creditCardLoan) : this.creditCardLoan as OpenApplicationResult;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumerLoan = _data["consumerLoan"] ? OpenApplicationResult.fromJS(_data["consumerLoan"]) : undefined as any;
            this.restartLoan = _data["restartLoan"] ? OpenApplicationResult.fromJS(_data["restartLoan"]) : undefined as any;
            this.creditCardLoan = _data["creditCardLoan"] ? OpenApplicationResult.fromJS(_data["creditCardLoan"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetOpenApplicationsQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOpenApplicationsQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerLoan"] = this.consumerLoan ? this.consumerLoan.toJSON() : undefined as any;
        data["restartLoan"] = this.restartLoan ? this.restartLoan.toJSON() : undefined as any;
        data["creditCardLoan"] = this.creditCardLoan ? this.creditCardLoan.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetOpenApplicationsQueryResponse {
    consumerLoan: IOpenApplicationResult;
    restartLoan: IOpenApplicationResult;
    creditCardLoan: IOpenApplicationResult;
}

export class Guarantor implements IGuarantor {
    socialNumber!: string;
    email!: string;
    phoneNumber!: string;

    constructor(data?: IGuarantor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialNumber = _data["socialNumber"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): Guarantor {
        data = typeof data === 'object' ? data : {};
        let result = new Guarantor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialNumber"] = this.socialNumber;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IGuarantor {
    socialNumber: string;
    email: string;
    phoneNumber: string;
}

export enum HasCarLoan {
    Yes = "Yes",
    No = "No",
    Leasing = "Leasing",
}

export enum HousingSituation {
    Rents = "Rents",
    OwnsHouse = "OwnsHouse",
    None = "None",
}

export class IncludeCreditCardApplication implements IIncludeCreditCardApplication {
    creditCardLimit!: number;

    constructor(data?: IIncludeCreditCardApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creditCardLimit = _data["creditCardLimit"];
        }
    }

    static fromJS(data: any): IncludeCreditCardApplication {
        data = typeof data === 'object' ? data : {};
        let result = new IncludeCreditCardApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditCardLimit"] = this.creditCardLimit;
        return data;
    }
}

export interface IIncludeCreditCardApplication {
    creditCardLimit: number;
}

export class ListCustomerApplicationsResponse implements IListCustomerApplicationsResponse {
    items!: OpenApplicationClientView[];

    constructor(data?: IListCustomerApplicationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(item as any).toJSON ? new OpenApplicationClientView(item) : item as OpenApplicationClientView;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OpenApplicationClientView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListCustomerApplicationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListCustomerApplicationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IListCustomerApplicationsResponse {
    items: IOpenApplicationClientView[];
}

export class LoanApplicationCacheDto implements ILoanApplicationCacheDto {
    form!: LoanApplicationSubmissionFormDto;
    page!: string;
    appPage!: string;

    constructor(data?: ILoanApplicationCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.form = data.form && !(data.form as any).toJSON ? new LoanApplicationSubmissionFormDto(data.form) : this.form as LoanApplicationSubmissionFormDto;
        }
        if (!data) {
            this.form = new LoanApplicationSubmissionFormDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.form = _data["form"] ? LoanApplicationSubmissionFormDto.fromJS(_data["form"]) : new LoanApplicationSubmissionFormDto();
            this.page = _data["page"];
            this.appPage = _data["appPage"];
        }
    }

    static fromJS(data: any): LoanApplicationCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoanApplicationCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["form"] = this.form ? this.form.toJSON() : undefined as any;
        data["page"] = this.page;
        data["appPage"] = this.appPage;
        return data;
    }
}

export interface ILoanApplicationCacheDto {
    form: ILoanApplicationSubmissionFormDto;
    page: string;
    appPage: string;
}

export class LoanApplicationClientView implements ILoanApplicationClientView {
    applicationId!: string;
    product!: PartnerProductType;
    submittedAt!: Date;
    closed!: boolean;
    rejectedByAllPartners!: boolean;
    appliedWithCoApplicant!: boolean;
    partners!: PartnerSubmissionClientView[];
    readonly hasAcceptedAnOffer!: boolean;
    readonly disbursedAt!: Date | undefined;
    qualifiesForRestartLoan!: boolean;

    constructor(data?: ILoanApplicationClientView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.partners) {
                this.partners = [];
                for (let i = 0; i < data.partners.length; i++) {
                    let item = data.partners[i];
                    this.partners[i] = item && !(item as any).toJSON ? new PartnerSubmissionClientView(item) : item as PartnerSubmissionClientView;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.product = _data["product"];
            this.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : undefined as any;
            this.closed = _data["closed"];
            this.rejectedByAllPartners = _data["rejectedByAllPartners"];
            this.appliedWithCoApplicant = _data["appliedWithCoApplicant"];
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(PartnerSubmissionClientView.fromJS(item));
            }
            (this as any).hasAcceptedAnOffer = _data["hasAcceptedAnOffer"];
            (this as any).disbursedAt = _data["disbursedAt"] ? new Date(_data["disbursedAt"].toString()) : undefined as any;
            this.qualifiesForRestartLoan = _data["qualifiesForRestartLoan"];
        }
    }

    static fromJS(data: any): LoanApplicationClientView {
        data = typeof data === 'object' ? data : {};
        let result = new LoanApplicationClientView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["product"] = this.product;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined as any;
        data["closed"] = this.closed;
        data["rejectedByAllPartners"] = this.rejectedByAllPartners;
        data["appliedWithCoApplicant"] = this.appliedWithCoApplicant;
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasAcceptedAnOffer"] = this.hasAcceptedAnOffer;
        data["disbursedAt"] = this.disbursedAt ? this.disbursedAt.toISOString() : undefined as any;
        data["qualifiesForRestartLoan"] = this.qualifiesForRestartLoan;
        return data;
    }
}

export interface ILoanApplicationClientView {
    applicationId: string;
    product: PartnerProductType;
    submittedAt: Date;
    closed: boolean;
    rejectedByAllPartners: boolean;
    appliedWithCoApplicant: boolean;
    partners: IPartnerSubmissionClientView[];
    hasAcceptedAnOffer: boolean;
    disbursedAt: Date | undefined;
    qualifiesForRestartLoan: boolean;
}

export class LoanApplicationSubmissionFormDto implements ILoanApplicationSubmissionFormDto {
    product!: PartnerProductType | undefined;
    applicant!: Applicant;
    newLoanAmount!: number;
    totalRefinancing!: number;
    purpose!: LoanPurpose | undefined;
    existingDebt!: SubmissionFormUnsecuredDebt[];
    hasOtherDebt!: boolean | undefined;
    totalOtherDebt!: number | undefined;
    numberOfPaymentRemarks!: number | undefined;
    housingSituation!: HousingSituation | undefined;
    mortgage!: Mortgage;
    reportedProperties!: ReportedProperty[];
    rentExpense!: number | undefined;
    yearlyGrossIncome!: number | undefined;
    monthlyNetIncome!: number | undefined;
    hasRentIncome!: boolean | undefined;
    rentIncome!: number | undefined;
    hasOtherIncome!: boolean | undefined;
    otherIncome!: number | undefined;
    otherIncomeDescription!: string;
    recievesChildSupport!: boolean | undefined;
    childSupportRecievedMonthly!: number | undefined;
    coApplicantIncluded!: boolean | undefined;
    coApplicants!: CoApplicant[];
    hasStudentLoan!: boolean | undefined;
    totalStudentLoan!: number | undefined;
    hasCarLoan!: HasCarLoan | undefined;
    totalCarLoan!: number | undefined;
    leasingExpenseMonthly!: number | undefined;
    hasGuarantor!: boolean | undefined;
    client!: Client;
    guarantor!: Guarantor | undefined;
    selfReportedPaymentRemarks!: SelfReportedPaymentRemarks | undefined;

    constructor(data?: ILoanApplicationSubmissionFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.applicant = data.applicant && !(data.applicant as any).toJSON ? new Applicant(data.applicant) : this.applicant as Applicant;
            if (data.existingDebt) {
                this.existingDebt = [];
                for (let i = 0; i < data.existingDebt.length; i++) {
                    let item = data.existingDebt[i];
                    this.existingDebt[i] = item && !(item as any).toJSON ? new SubmissionFormUnsecuredDebt(item) : item as SubmissionFormUnsecuredDebt;
                }
            }
            this.mortgage = data.mortgage && !(data.mortgage as any).toJSON ? new Mortgage(data.mortgage) : this.mortgage as Mortgage;
            if (data.reportedProperties) {
                this.reportedProperties = [];
                for (let i = 0; i < data.reportedProperties.length; i++) {
                    let item = data.reportedProperties[i];
                    this.reportedProperties[i] = item && !(item as any).toJSON ? new ReportedProperty(item) : item as ReportedProperty;
                }
            }
            if (data.coApplicants) {
                this.coApplicants = [];
                for (let i = 0; i < data.coApplicants.length; i++) {
                    let item = data.coApplicants[i];
                    this.coApplicants[i] = item && !(item as any).toJSON ? new CoApplicant(item) : item as CoApplicant;
                }
            }
            this.client = data.client && !(data.client as any).toJSON ? new Client(data.client) : this.client as Client;
            this.guarantor = data.guarantor && !(data.guarantor as any).toJSON ? new Guarantor(data.guarantor) : this.guarantor as Guarantor;
        }
        if (!data) {
            this.applicant = new Applicant();
            this.mortgage = new Mortgage();
            this.coApplicants = [];
            this.client = new Client();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"];
            this.applicant = _data["applicant"] ? Applicant.fromJS(_data["applicant"]) : new Applicant();
            this.newLoanAmount = _data["newLoanAmount"];
            this.totalRefinancing = _data["totalRefinancing"];
            this.purpose = _data["purpose"];
            if (Array.isArray(_data["existingDebt"])) {
                this.existingDebt = [] as any;
                for (let item of _data["existingDebt"])
                    this.existingDebt!.push(SubmissionFormUnsecuredDebt.fromJS(item));
            }
            this.hasOtherDebt = _data["hasOtherDebt"];
            this.totalOtherDebt = _data["totalOtherDebt"];
            this.numberOfPaymentRemarks = _data["numberOfPaymentRemarks"];
            this.housingSituation = _data["housingSituation"];
            this.mortgage = _data["mortgage"] ? Mortgage.fromJS(_data["mortgage"]) : new Mortgage();
            if (Array.isArray(_data["reportedProperties"])) {
                this.reportedProperties = [] as any;
                for (let item of _data["reportedProperties"])
                    this.reportedProperties!.push(ReportedProperty.fromJS(item));
            }
            this.rentExpense = _data["rentExpense"];
            this.yearlyGrossIncome = _data["yearlyGrossIncome"];
            this.monthlyNetIncome = _data["monthlyNetIncome"];
            this.hasRentIncome = _data["hasRentIncome"];
            this.rentIncome = _data["rentIncome"];
            this.hasOtherIncome = _data["hasOtherIncome"];
            this.otherIncome = _data["otherIncome"];
            this.otherIncomeDescription = _data["otherIncomeDescription"];
            this.recievesChildSupport = _data["recievesChildSupport"];
            this.childSupportRecievedMonthly = _data["childSupportRecievedMonthly"];
            this.coApplicantIncluded = _data["coApplicantIncluded"];
            if (Array.isArray(_data["coApplicants"])) {
                this.coApplicants = [] as any;
                for (let item of _data["coApplicants"])
                    this.coApplicants!.push(CoApplicant.fromJS(item));
            }
            this.hasStudentLoan = _data["hasStudentLoan"];
            this.totalStudentLoan = _data["totalStudentLoan"];
            this.hasCarLoan = _data["hasCarLoan"];
            this.totalCarLoan = _data["totalCarLoan"];
            this.leasingExpenseMonthly = _data["leasingExpenseMonthly"];
            this.hasGuarantor = _data["hasGuarantor"];
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : new Client();
            this.guarantor = _data["guarantor"] ? Guarantor.fromJS(_data["guarantor"]) : undefined as any;
            this.selfReportedPaymentRemarks = _data["selfReportedPaymentRemarks"];
        }
    }

    static fromJS(data: any): LoanApplicationSubmissionFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoanApplicationSubmissionFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : undefined as any;
        data["newLoanAmount"] = this.newLoanAmount;
        data["totalRefinancing"] = this.totalRefinancing;
        data["purpose"] = this.purpose;
        if (Array.isArray(this.existingDebt)) {
            data["existingDebt"] = [];
            for (let item of this.existingDebt)
                data["existingDebt"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasOtherDebt"] = this.hasOtherDebt;
        data["totalOtherDebt"] = this.totalOtherDebt;
        data["numberOfPaymentRemarks"] = this.numberOfPaymentRemarks;
        data["housingSituation"] = this.housingSituation;
        data["mortgage"] = this.mortgage ? this.mortgage.toJSON() : undefined as any;
        if (Array.isArray(this.reportedProperties)) {
            data["reportedProperties"] = [];
            for (let item of this.reportedProperties)
                data["reportedProperties"].push(item ? item.toJSON() : undefined as any);
        }
        data["rentExpense"] = this.rentExpense;
        data["yearlyGrossIncome"] = this.yearlyGrossIncome;
        data["monthlyNetIncome"] = this.monthlyNetIncome;
        data["hasRentIncome"] = this.hasRentIncome;
        data["rentIncome"] = this.rentIncome;
        data["hasOtherIncome"] = this.hasOtherIncome;
        data["otherIncome"] = this.otherIncome;
        data["otherIncomeDescription"] = this.otherIncomeDescription;
        data["recievesChildSupport"] = this.recievesChildSupport;
        data["childSupportRecievedMonthly"] = this.childSupportRecievedMonthly;
        data["coApplicantIncluded"] = this.coApplicantIncluded;
        if (Array.isArray(this.coApplicants)) {
            data["coApplicants"] = [];
            for (let item of this.coApplicants)
                data["coApplicants"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasStudentLoan"] = this.hasStudentLoan;
        data["totalStudentLoan"] = this.totalStudentLoan;
        data["hasCarLoan"] = this.hasCarLoan;
        data["totalCarLoan"] = this.totalCarLoan;
        data["leasingExpenseMonthly"] = this.leasingExpenseMonthly;
        data["hasGuarantor"] = this.hasGuarantor;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["guarantor"] = this.guarantor ? this.guarantor.toJSON() : undefined as any;
        data["selfReportedPaymentRemarks"] = this.selfReportedPaymentRemarks;
        return data;
    }
}

export interface ILoanApplicationSubmissionFormDto {
    product: PartnerProductType | undefined;
    applicant: IApplicant;
    newLoanAmount: number;
    totalRefinancing: number;
    purpose: LoanPurpose | undefined;
    existingDebt: ISubmissionFormUnsecuredDebt[];
    hasOtherDebt: boolean | undefined;
    totalOtherDebt: number | undefined;
    numberOfPaymentRemarks: number | undefined;
    housingSituation: HousingSituation | undefined;
    mortgage: IMortgage;
    reportedProperties: IReportedProperty[];
    rentExpense: number | undefined;
    yearlyGrossIncome: number | undefined;
    monthlyNetIncome: number | undefined;
    hasRentIncome: boolean | undefined;
    rentIncome: number | undefined;
    hasOtherIncome: boolean | undefined;
    otherIncome: number | undefined;
    otherIncomeDescription: string;
    recievesChildSupport: boolean | undefined;
    childSupportRecievedMonthly: number | undefined;
    coApplicantIncluded: boolean | undefined;
    coApplicants: ICoApplicant[];
    hasStudentLoan: boolean | undefined;
    totalStudentLoan: number | undefined;
    hasCarLoan: HasCarLoan | undefined;
    totalCarLoan: number | undefined;
    leasingExpenseMonthly: number | undefined;
    hasGuarantor: boolean | undefined;
    client: IClient;
    guarantor: IGuarantor | undefined;
    selfReportedPaymentRemarks: SelfReportedPaymentRemarks | undefined;
}

export enum LoanPurpose {
    Refinancing = "Refinancing",
    Renovation = "Renovation",
    TravelLeisure = "TravelLeisure",
    Bills = "Bills",
    Medical = "Medical",
    Reparation = "Reparation",
    Car = "Car",
    BoatCaravan = "BoatCaravan",
    House = "House",
    Others = "Others",
}

export enum MaritalStatusType {
    Single = "Single",
    Cohabitant = "Cohabitant",
    Married = "Married",
    Separated = "Separated",
    Divorced = "Divorced",
    Widow = "Widow",
}

export class Mortgage implements IMortgage {
    hasMortgage!: boolean | undefined;
    isSplit!: boolean | undefined;
    ownershipPercentage!: number | undefined;
    remaining!: number | undefined;
    monthlyPayment!: number | undefined;

    constructor(data?: IMortgage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasMortgage = _data["hasMortgage"];
            this.isSplit = _data["isSplit"];
            this.ownershipPercentage = _data["ownershipPercentage"];
            this.remaining = _data["remaining"];
            this.monthlyPayment = _data["monthlyPayment"];
        }
    }

    static fromJS(data: any): Mortgage {
        data = typeof data === 'object' ? data : {};
        let result = new Mortgage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasMortgage"] = this.hasMortgage;
        data["isSplit"] = this.isSplit;
        data["ownershipPercentage"] = this.ownershipPercentage;
        data["remaining"] = this.remaining;
        data["monthlyPayment"] = this.monthlyPayment;
        return data;
    }
}

export interface IMortgage {
    hasMortgage: boolean | undefined;
    isSplit: boolean | undefined;
    ownershipPercentage: number | undefined;
    remaining: number | undefined;
    monthlyPayment: number | undefined;
}

export enum NumberOfChildren {
    None = "None",
    One = "One",
    Two = "Two",
    Three = "Three",
    FourOrAbove = "FourOrAbove",
}

export enum OfferQuality {
    None = "None",
    LowestCostPerPeriod = "LowestCostPerPeriod",
    LowestEffectiveInterestRate = "LowestEffectiveInterestRate",
    LowestCostAndLowestEffectiveRate = "LowestCostAndLowestEffectiveRate",
}

export class OpenApplicationClientView implements IOpenApplicationClientView {
    id!: string;
    createdOn!: Date;
    product!: PartnerProductType;

    constructor(data?: IOpenApplicationClientView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.product = _data["product"];
        }
    }

    static fromJS(data: any): OpenApplicationClientView {
        data = typeof data === 'object' ? data : {};
        let result = new OpenApplicationClientView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["product"] = this.product;
        return data;
    }
}

export interface IOpenApplicationClientView {
    id: string;
    createdOn: Date;
    product: PartnerProductType;
}

export class OpenApplicationResult implements IOpenApplicationResult {
    id!: string;
    hasAcceptedAnOffer!: boolean;
    readonly hasOpenApplication!: boolean;

    constructor(data?: IOpenApplicationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasAcceptedAnOffer = _data["hasAcceptedAnOffer"];
            (this as any).hasOpenApplication = _data["hasOpenApplication"];
        }
    }

    static fromJS(data: any): OpenApplicationResult {
        data = typeof data === 'object' ? data : {};
        let result = new OpenApplicationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasAcceptedAnOffer"] = this.hasAcceptedAnOffer;
        data["hasOpenApplication"] = this.hasOpenApplication;
        return data;
    }
}

export interface IOpenApplicationResult {
    id: string;
    hasAcceptedAnOffer: boolean;
    hasOpenApplication: boolean;
}

export enum PartnerProductType {
    ConsumerLoan = "ConsumerLoan",
    RestartLoan = "RestartLoan",
    MortgageLoan = "MortgageLoan",
    CreditCard = "CreditCard",
}

export class PartnerSubmissionClientView implements IPartnerSubmissionClientView {
    partnerId!: string;
    partnerName!: string;
    state!: PartnerSubmissionState;
    primaryOffer!: ApplicationOfferClientView | undefined;
    comboOffer!: ApplicationComboOfferClientView | undefined;
    dualOffer!: ApplicationOfferClientView | undefined;
    partnerInfoMessage!: string | undefined;
    readonly isRejected!: boolean;
    readonly hasOffer!: boolean;
    readonly hasAccepted!: boolean;
    readonly disbursedAt!: Date | undefined;

    constructor(data?: IPartnerSubmissionClientView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.primaryOffer = data.primaryOffer && !(data.primaryOffer as any).toJSON ? new ApplicationOfferClientView(data.primaryOffer) : this.primaryOffer as ApplicationOfferClientView;
            this.comboOffer = data.comboOffer && !(data.comboOffer as any).toJSON ? new ApplicationComboOfferClientView(data.comboOffer) : this.comboOffer as ApplicationComboOfferClientView;
            this.dualOffer = data.dualOffer && !(data.dualOffer as any).toJSON ? new ApplicationOfferClientView(data.dualOffer) : this.dualOffer as ApplicationOfferClientView;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.partnerName = _data["partnerName"];
            this.state = _data["state"];
            this.primaryOffer = _data["primaryOffer"] ? ApplicationOfferClientView.fromJS(_data["primaryOffer"]) : undefined as any;
            this.comboOffer = _data["comboOffer"] ? ApplicationComboOfferClientView.fromJS(_data["comboOffer"]) : undefined as any;
            this.dualOffer = _data["dualOffer"] ? ApplicationOfferClientView.fromJS(_data["dualOffer"]) : undefined as any;
            this.partnerInfoMessage = _data["partnerInfoMessage"];
            (this as any).isRejected = _data["isRejected"];
            (this as any).hasOffer = _data["hasOffer"];
            (this as any).hasAccepted = _data["hasAccepted"];
            (this as any).disbursedAt = _data["disbursedAt"] ? new Date(_data["disbursedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PartnerSubmissionClientView {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSubmissionClientView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["partnerName"] = this.partnerName;
        data["state"] = this.state;
        data["primaryOffer"] = this.primaryOffer ? this.primaryOffer.toJSON() : undefined as any;
        data["comboOffer"] = this.comboOffer ? this.comboOffer.toJSON() : undefined as any;
        data["dualOffer"] = this.dualOffer ? this.dualOffer.toJSON() : undefined as any;
        data["partnerInfoMessage"] = this.partnerInfoMessage;
        data["isRejected"] = this.isRejected;
        data["hasOffer"] = this.hasOffer;
        data["hasAccepted"] = this.hasAccepted;
        data["disbursedAt"] = this.disbursedAt ? this.disbursedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IPartnerSubmissionClientView {
    partnerId: string;
    partnerName: string;
    state: PartnerSubmissionState;
    primaryOffer: IApplicationOfferClientView | undefined;
    comboOffer: IApplicationComboOfferClientView | undefined;
    dualOffer: IApplicationOfferClientView | undefined;
    partnerInfoMessage: string | undefined;
    isRejected: boolean;
    hasOffer: boolean;
    hasAccepted: boolean;
    disbursedAt: Date | undefined;
}

export enum PartnerSubmissionState {
    RejectedByFilters = "RejectedByFilters",
    ContactingPartner = "ContactingPartner",
    ApplicationSubmitted = "ApplicationSubmitted",
    TimedOut = "TimedOut",
    CaseCreated = "CaseCreated",
    RejectedByPartner = "RejectedByPartner",
    RejectedByCustomerSupport = "RejectedByCustomerSupport",
    OfferGiven = "OfferGiven",
    OfferAcceptedByApplicant = "OfferAcceptedByApplicant",
    OfferAcceptedAtPartner = "OfferAcceptedAtPartner",
    Cancelling = "Cancelling",
    SubmissionCancelled = "SubmissionCancelled",
    PartnerAwaitsDocumentation = "PartnerAwaitsDocumentation",
    ReadyForSignatures = "ReadyForSignatures",
    SignedByApplicant = "SignedByApplicant",
    PaidOut = "PaidOut",
    Error = "Error",
    SubmissionFailed = "SubmissionFailed",
    Duplicate = "Duplicate",
}

export enum PropertyReportSource {
    SelfReported = "SelfReported",
    PropertyRegistry = "PropertyRegistry",
}

export enum PropertyType {
    House = "House",
    Apartment = "Apartment",
    HolidayHome = "HolidayHome",
    SemiDetachedHouse = "SemiDetachedHouse",
    SemiDetachedHouseVertical = "SemiDetachedHouseVertical",
    SerialHouse = "SerialHouse",
}

export class Reason implements IReason {
    cancellationReasons!: CancellationReasonType[];
    userDefinedReason!: string | undefined;

    constructor(data?: IReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cancellationReasons"])) {
                this.cancellationReasons = [] as any;
                for (let item of _data["cancellationReasons"])
                    this.cancellationReasons!.push(item);
            }
            this.userDefinedReason = _data["userDefinedReason"];
        }
    }

    static fromJS(data: any): Reason {
        data = typeof data === 'object' ? data : {};
        let result = new Reason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cancellationReasons)) {
            data["cancellationReasons"] = [];
            for (let item of this.cancellationReasons)
                data["cancellationReasons"].push(item);
        }
        data["userDefinedReason"] = this.userDefinedReason;
        return data;
    }
}

export interface IReason {
    cancellationReasons: CancellationReasonType[];
    userDefinedReason: string | undefined;
}

export class ReportedProperty implements IReportedProperty {
    source!: PropertyReportSource;
    address!: string;
    type!: PropertyType;
    floorCode!: string;
    areaSize!: number;
    estimatedValue!: number;
    municipalityName!: string;
    postalCode!: string;
    cadastral!: Cadastral;
    ownershipPercentage!: number | undefined;
    electronicEvaluationRefNumber!: string;
    checked!: boolean;

    constructor(data?: IReportedProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.cadastral = data.cadastral && !(data.cadastral as any).toJSON ? new Cadastral(data.cadastral) : this.cadastral as Cadastral;
        }
        if (!data) {
            this.cadastral = new Cadastral();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.address = _data["address"];
            this.type = _data["type"];
            this.floorCode = _data["floorCode"];
            this.areaSize = _data["areaSize"];
            this.estimatedValue = _data["estimatedValue"];
            this.municipalityName = _data["municipalityName"];
            this.postalCode = _data["postalCode"];
            this.cadastral = _data["cadastral"] ? Cadastral.fromJS(_data["cadastral"]) : new Cadastral();
            this.ownershipPercentage = _data["ownershipPercentage"];
            this.electronicEvaluationRefNumber = _data["electronicEvaluationRefNumber"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): ReportedProperty {
        data = typeof data === 'object' ? data : {};
        let result = new ReportedProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["address"] = this.address;
        data["type"] = this.type;
        data["floorCode"] = this.floorCode;
        data["areaSize"] = this.areaSize;
        data["estimatedValue"] = this.estimatedValue;
        data["municipalityName"] = this.municipalityName;
        data["postalCode"] = this.postalCode;
        data["cadastral"] = this.cadastral ? this.cadastral.toJSON() : undefined as any;
        data["ownershipPercentage"] = this.ownershipPercentage;
        data["electronicEvaluationRefNumber"] = this.electronicEvaluationRefNumber;
        data["checked"] = this.checked;
        return data;
    }
}

export interface IReportedProperty {
    source: PropertyReportSource;
    address: string;
    type: PropertyType;
    floorCode: string;
    areaSize: number;
    estimatedValue: number;
    municipalityName: string;
    postalCode: string;
    cadastral: ICadastral;
    ownershipPercentage: number | undefined;
    electronicEvaluationRefNumber: string;
    checked: boolean;
}

export enum SelfReportedPaymentRemarks {
    DontKnow = "DontKnow",
    Yes = "Yes",
    No = "No",
}

export class SubmissionFormUnsecuredDebt implements ISubmissionFormUnsecuredDebt {
    type!: DebtType;
    bankName!: string;
    borrowed!: number | undefined;
    remaining!: number | undefined;
    limit!: number | undefined;
    nominalInterestRate!: number | undefined;
    effectiveInterestRate!: number | undefined;
    monthsRemainingOnDownPayment!: number | undefined;
    totalMonthlyFee!: number | undefined;
    refinance!: boolean | undefined;

    constructor(data?: ISubmissionFormUnsecuredDebt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.bankName = _data["bankName"];
            this.borrowed = _data["borrowed"];
            this.remaining = _data["remaining"];
            this.limit = _data["limit"];
            this.nominalInterestRate = _data["nominalInterestRate"];
            this.effectiveInterestRate = _data["effectiveInterestRate"];
            this.monthsRemainingOnDownPayment = _data["monthsRemainingOnDownPayment"];
            this.totalMonthlyFee = _data["totalMonthlyFee"];
            this.refinance = _data["refinance"];
        }
    }

    static fromJS(data: any): SubmissionFormUnsecuredDebt {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionFormUnsecuredDebt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["bankName"] = this.bankName;
        data["borrowed"] = this.borrowed;
        data["remaining"] = this.remaining;
        data["limit"] = this.limit;
        data["nominalInterestRate"] = this.nominalInterestRate;
        data["effectiveInterestRate"] = this.effectiveInterestRate;
        data["monthsRemainingOnDownPayment"] = this.monthsRemainingOnDownPayment;
        data["totalMonthlyFee"] = this.totalMonthlyFee;
        data["refinance"] = this.refinance;
        return data;
    }
}

export interface ISubmissionFormUnsecuredDebt {
    type: DebtType;
    bankName: string;
    borrowed: number | undefined;
    remaining: number | undefined;
    limit: number | undefined;
    nominalInterestRate: number | undefined;
    effectiveInterestRate: number | undefined;
    monthsRemainingOnDownPayment: number | undefined;
    totalMonthlyFee: number | undefined;
    refinance: boolean | undefined;
}

export class SubmitLoanApplicationRequest implements ISubmitLoanApplicationRequest {
    form!: LoanApplicationSubmissionFormDto;
    includeCreditCardApplication!: IncludeCreditCardApplication | undefined;

    constructor(data?: ISubmitLoanApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.form = data.form && !(data.form as any).toJSON ? new LoanApplicationSubmissionFormDto(data.form) : this.form as LoanApplicationSubmissionFormDto;
            this.includeCreditCardApplication = data.includeCreditCardApplication && !(data.includeCreditCardApplication as any).toJSON ? new IncludeCreditCardApplication(data.includeCreditCardApplication) : this.includeCreditCardApplication as IncludeCreditCardApplication;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.form = _data["form"] ? LoanApplicationSubmissionFormDto.fromJS(_data["form"]) : undefined as any;
            this.includeCreditCardApplication = _data["includeCreditCardApplication"] ? IncludeCreditCardApplication.fromJS(_data["includeCreditCardApplication"]) : undefined as any;
        }
    }

    static fromJS(data: any): SubmitLoanApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitLoanApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["form"] = this.form ? this.form.toJSON() : undefined as any;
        data["includeCreditCardApplication"] = this.includeCreditCardApplication ? this.includeCreditCardApplication.toJSON() : undefined as any;
        return data;
    }
}

export interface ISubmitLoanApplicationRequest {
    form: ILoanApplicationSubmissionFormDto;
    includeCreditCardApplication: IIncludeCreditCardApplication | undefined;
}

export class SubmitLoanApplicationResponse implements ISubmitLoanApplicationResponse {
    id!: string;
    creditApplicationId!: string | undefined;

    constructor(data?: ISubmitLoanApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creditApplicationId = _data["creditApplicationId"];
        }
    }

    static fromJS(data: any): SubmitLoanApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitLoanApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creditApplicationId"] = this.creditApplicationId;
        return data;
    }
}

export interface ISubmitLoanApplicationResponse {
    id: string;
    creditApplicationId: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}